// The depth's copy (#218): Level 3's practice, papers, calibration, confusions and the reading of a
// paper's argument, in our own words in nl and en. Nothing here names an outside body, a price, a
// pass or a fail, a provider, a retention rule or a confidence: those have no place in the app.
// i18n.ts spreads these into the two dictionaries; the other five locales read Dutch.
export const depthCopy = {
  nl: {
    "learn.practice.title": "Oefenen",
    "learn.practice.all": "Alles",
    "learn.practice.drills-title": "Oefenen zonder glas",
    "learn.practice.drills-hint": "{n} oefeningen staan klaar",
    "learn.practice.primary": "Oefen {n} items",
    "learn.practice.confusions-title": "Gericht op wat je verwart",
    "learn.practice.confusion-pair": "{called} voor {actual}",
    "learn.practice.confusion-count": "{n}× gemist",
    "learn.practice.paper-title": "Proefwerk op tijd",
    "learn.practice.paper-hint": "Twee wijnen · {m} minuten · {sat} gezeten",
    "learn.practice.paper-start": "Zit een proefwerk",
    "learn.practice.paper-locked": "Gaat open zodra alle lessen van niveau 2 zijn afgerond.",
    "learn.practice.paper-locked-left": "Nog {n} lessen van niveau 2.",
    "learn.practice.empty-title": "Niets te oefenen",
    "learn.practice.empty-body": "Je hoeft vandaag niets te doen om bij te blijven.",
    "learn.practice.running-title": "Je proefwerk loopt",
    "learn.practice.running-resume": "Ga verder met het proefwerk",
    "learn.practice.running-left": "Nog {time}",
    "learn.practice.essays": "Je bewaarde antwoorden",
    "learn.practice.sync-error":
      "Je oefenwerk kon niet worden bijgewerkt; het staat veilig op dit toestel en wordt later opnieuw geprobeerd.",
    "learn.practice.sync-refused":
      "Eén onderdeel kon niet worden bijgewerkt en is opzij gezet. De rest is bijgewerkt.",
    "learn.practice.mirror-damaged":
      "Een deel van je oefenwerk was niet meer te lezen; we tonen wat er nog te lezen is.",

    "learn.path.practice-hint": "Oefeningen, verwarringen en een proefwerk",
    "learn.path.mastery-hint": "Je niveaus, kalibratie en families",

    "learn.mastery.title": "Beheersing",
    "learn.mastery.levels-title": "Per niveau",
    "learn.mastery.level": "Niveau {n}",
    "learn.mastery.calibration-title": "Kalibratie per as",
    "learn.mastery.calibration-hint": "Hoe ver je ladderkeuzes van de referentie liggen.",
    "learn.mastery.calibration-empty-title": "Nog niets gekalibreerd",
    "learn.mastery.calibration-empty-body":
      "Proef mee in een groep van drie of meer, of zit een proefwerk.",
    "learn.mastery.families-title": "Trefzekerheid per familie",
    "learn.mastery.family-share": "{correct} van {total} goed",
    "learn.mastery.family-empty": "Nog niet blind geproefd",
    "learn.mastery.spark-aria": "Per week: {weeks}",

    "learn.calibration.n-of-3": "{n} van {min}",
    "learn.calibration.on-target": "Op koers",
    "learn.calibration.lower": "Je noemt lager",
    "learn.calibration.higher": "Je noemt hoger",
    "learn.calibration.basis": "Op basis van {n} keuzes",
    "learn.calibration.meter-aria": "{axis}: {word}, {steps} trede, op basis van {n} keuzes",
    "learn.calibration.end-low": "Lager",
    "learn.calibration.end-high": "Hoger",
    "learn.calibration.model-ref": "Referentie: modelantwoord, geen groep",
    "learn.calibration.group-ref": "Referentie: de groep",
    "learn.calibration.no-reference": "Geen referentie",
    "learn.calibration.too-few-title": "Te weinig proevers voor kalibratie",
    "learn.calibration.too-few-body":
      "Kalibratie heeft een groep van drie of meer nodig. Zit een proefwerk om tegen het modelantwoord te kalibreren.",
    "learn.calibration.pending": "Kalibratie wacht tot de proeverij klaar is.",
    "learn.calibration.offline":
      "Geen verbinding: het groepscijfer is nog niet beschikbaar. Wat je eerder kalibreerde blijft staan.",
    "learn.calibration.screen-title": "Kalibratie",
    "learn.calibration.wine": "Wijn {n}",
    "learn.calibration.you": "Jij",
    "learn.calibration.group": "Groep",
    "learn.calibration.between": "tussen {a} en {b}",
    "learn.calibration.open": "Kalibratie van deze proeverij",
    "learn.calibration.to-paper": "Zit een proefwerk",
    "learn.calibration.axis-acidity": "Zuren",
    "learn.calibration.axis-tannin": "Tannine",
    "learn.calibration.axis-flavour-intensity": "Smaakintensiteit",
    "learn.calibration.axis-body": "Body",
    "learn.calibration.axis-finish": "Afdronk",
    "learn.calibration.axis-aroma-intensity": "Aromaintensiteit",

    "learn.confusions.title": "Je verwarringen",
    "learn.confusions.how":
      "Elke keer dat je bij een onthulling een andere druif noemde, tellen we het paar. Een paar dat terugkomt wordt een oefening.",
    "learn.confusions.empty-title": "Nog geen verwarringen",
    "learn.confusions.empty-body":
      "Noem een druif bij een blinde proef en onthul hem; wat je mist verschijnt hier.",
    "learn.confusions.times": "{n} keer",
    "learn.confusions.drills-ready": "Oefeningen klaar",
    "learn.confusions.no-target": "Nog geen doel",
    "learn.confusions.practise": "Oefen je verwarringen",
    "learn.confusions.drill-target": "Gericht · {called} voor {actual}",

    "learn.reveal.was": "Het was",
    "learn.reveal.right": "Goed",
    "learn.reveal.not-this": "Niet deze",
    "learn.reveal.same-family": "Zelfde familie",
    "learn.reveal.not-named": "Niet genoemd",
    "learn.reveal.recorded": "Vastgelegd bij je oefeningen.",

    "learn.room.friends": "Met vrienden of een groep",
    "learn.room.title": "Proefwerk met vrienden",
    "learn.room.name-label": "Je naam in de kamer",
    "learn.room.create": "Open een kamer",
    "learn.room.code": "Code",
    "learn.room.share": "Nodig mensen uit",
    "learn.room.share-title": "Zit mee",
    "learn.room.share-text": "{name} opent een proefwerk met twee wijnen. Doe je mee?",
    "learn.room.share-lead": "Er gaat alleen de naam van de kamer en de code mee; geen antwoord.",
    "learn.room.host-only": "Schenk deze twee stijlen (alleen jij ziet dit)",
    "learn.room.guest-wait": "Wacht tot de gastheer start. De stijlen zie je bij de onthulling.",
    "learn.room.members": "Wie zit er",
    "learn.room.handed-in": "Ingeleverd",
    "learn.room.busy": "Bezig",
    "learn.room.start-all": "Start voor iedereen",
    "learn.room.clock-note":
      "De klok start voor iedereen tegelijk en loopt op de tijd van de kamer.",
    "learn.room.running": "De zitting loopt",
    "learn.room.sit": "Ga naar je zitting",
    "learn.room.my-result": "Je eigen resultaat",
    "learn.room.reveal": "Onthul voor iedereen",
    "learn.room.waiting-reveal": "Wachten op de onthulling van de gastheer.",
    "learn.room.reveal-title": "Samen onthuld",
    "learn.room.outcome-right": "Goed",
    "learn.room.outcome-family": "Zelfde familie",
    "learn.room.outcome-wrong": "Niet deze",
    "learn.room.outcome-none": "Niet genoemd",
    "learn.room.wine": "Wijn {n}",
    "learn.room.group-calibration": "Kalibratie tegen de groep",
    "learn.room.half-step": "Bij een even aantal deelnemers ligt de mediaan op een halve trede.",
    "learn.room.join-title": "Doe mee aan een proefwerk",
    "learn.room.join": "Meedoen",
    "learn.room.not-found": "Deze kamer bestaat niet of staat niet meer open voor jou.",
    "learn.room.full": "De kamer zit vol.",
    "learn.room.error": "De kamer kon niet worden bijgewerkt.",
    "learn.room.handin-pending":
      "Je zitting is bewaard. Inleveren in de kamer lukt zodra je verbinding hebt.",
    "learn.room.handin-retry": "Lever opnieuw in",
    "learn.room.to-room": "Naar de kamer",
    "learn.room.back": "Terug naar oefenen",

    "learn.paper.title": "Proefwerk",
    "learn.paper.ready-title": "Twee wijnen, {m} minuten",
    "learn.paper.fact-pour": "Twee keer 5 cl; spugen mag en hoort erbij.",
    "learn.paper.fact-time": "Na {m} minuten sluit de zitting vanzelf.",
    "learn.paper.fact-note": "Een diepe notitie per wijn en een onderbouwd oordeel.",
    "learn.paper.fact-practice":
      "Dit is oefening: je ziet je resultaat, het modelantwoord en wat je mist.",
    "learn.paper.pour-title": "Schenk deze twee stijlen",
    "learn.paper.pour-note":
      "Stijlen, geen flessen: elke fles die past, past. Laat iemand anders inschenken of draai de etiketten weg.",
    "learn.paper.budget": "Duur",
    "learn.paper.budget-1800": "30 min",
    "learn.paper.budget-1200": "20 min",
    "learn.paper.start": "Begin de zitting",
    "learn.paper.locked-title": "Het proefwerk gaat nog niet open",
    "learn.paper.locked-body": "Rond eerst niveau 2 af; daarna staat het voor je klaar.",
    "learn.paper.locked-cta": "Ga verder met niveau 2",
    "learn.paper.not-found": "Dit proefwerk bestaat niet.",
    "learn.paper.wine-tab": "Wijn {n}",
    "learn.paper.wines-aria": "De wijnen van het proefwerk",
    "learn.paper.elapsed-aria": "Verstreken tijd",
    "learn.paper.section-points": "{n} punten",
    "learn.paper.field-grape": "Druif",
    "learn.paper.field-country": "Land",
    "learn.paper.grape-pick": "Welke druif?",
    "learn.families.picker-hint": "Eerst de familie, dan de druif.",
    "learn.families.no-call": "Geen keuze · onthul zonder te raden",
    "learn.paper.grape-none": "Nog niet gekozen",
    "learn.paper.country-none": "Nog niet gekozen",
    "learn.paper.argument-label": "Onderbouw je oordeel in eigen woorden",
    "learn.paper.argument-hint": "Niets typen is prima; dan telt alleen wat je hierboven koos.",
    "learn.paper.hand-in": "Inleveren",
    "learn.paper.to-wine": "Naar wijn {n}",
    "learn.paper.time-left-aria": "Nog {m} minuten en {s} seconden. Tik om de tijd te horen.",
    "learn.paper.announce-ten-minutes": "Nog tien minuten.",
    "learn.paper.announce-five-minutes": "Nog vijf minuten.",
    "learn.paper.announce-one-minute": "Nog één minuut.",
    "learn.paper.announce-closed": "De zitting is gesloten.",
    "learn.paper.last-minute": "Nog één minuut. Wat er staat wordt dan ingeleverd.",
    "learn.paper.closed-title": "De zitting is gesloten",
    "learn.paper.closed-body": "De tijd is om; wat er stond is ingeleverd.",
    "learn.paper.closed-cta": "Bekijk het resultaat",
    "learn.paper.empty-wine-title": "Wijn {n} is nog leeg",
    "learn.paper.empty-wine-body": "Een lege wijn levert niets op.",
    "learn.paper.keep-going": "Verder schrijven",
    "learn.paper.hand-in-anyway": "Toch inleveren",
    "learn.paper.stop": "Stoppen",
    "learn.paper.stop-title": "Zitting stoppen?",
    "learn.paper.stop-keep": "Verder gaan",
    "learn.paper.stop-leave": "Weggaan, de klok loopt door",
    "learn.paper.stop-abandon": "Stoppen zonder resultaat",
    "learn.paper.stop-abandoned": "De zitting is gestopt. Je antwoorden blijven leesbaar.",
    "learn.paper.corrupted-title": "Een zitting kon niet worden gelezen",
    "learn.paper.corrupted-body": "De rest van je werk is er nog; deze zitting laten we los.",
    "learn.paper.band-emerging": "In opbouw",
    "learn.paper.band-developing": "In ontwikkeling",
    "learn.paper.band-secure": "Zeker",
    "learn.paper.band-strong": "Sterk",
    "learn.paper.band-note":
      "Vier banden: in opbouw, in ontwikkeling, zeker en sterk. Ze zeggen hoe ver je bent in deze oefening, niet of je slaagt.",
    "learn.paper.band-range": "Tussen {low} en {high}",
    "learn.paper.result-title": "Je resultaat",
    "learn.paper.score-of": "{n} van 100",
    "learn.paper.so-far": "{n} van 90 tot nu toe",
    "learn.paper.so-far-body": "De onderbouwing van je oordeel telt nog mee, maximaal {max}.",
    "learn.paper.pending-title": "Je cijfer volgt",
    "learn.paper.wine-result": "Wijn {n}",
    "learn.paper.archetype-was": "Het was {style}",
    "learn.paper.section-look": "Kijken",
    "learn.paper.section-nose": "Neus",
    "learn.paper.section-palate": "Mond",
    "learn.paper.section-conclusion": "Conclusie",
    "learn.paper.model-link": "Modelantwoord en nakijkgids",
    "learn.paper.model-title": "Modelantwoord en nakijkgids",
    "learn.paper.model-you": "Jij",
    "learn.paper.model-model": "Model",
    "learn.paper.mark-full": "Vol",
    "learn.paper.mark-half": "Half",
    "learn.paper.mark-none": "Niets",
    "learn.paper.guide-look": "Zo kom je bij het uiterlijk",
    "learn.paper.guide-nose": "Zo kom je bij de neus",
    "learn.paper.guide-palate": "Zo kom je bij de mond",
    "learn.paper.guide-quality": "Zo onderbouw je de kwaliteit",
    "learn.paper.guide-grape": "Zo kom je bij de druif",
    "learn.paper.model-rules":
      "Per punt dat je liet liggen staat er één regel over hoe je er zelf had kunnen komen.",
    "learn.paper.share": "Deel je resultaat",
    "learn.paper.share-title": "Mijn proefwerk",
    "learn.paper.share-text": "Mijn proefwerk: {band}, {score} van 100, {date}.",
    "learn.paper.share-lead":
      "Er gaat alleen je band, je score en de datum mee; geen notitie en geen antwoord.",
    "learn.paper.calibration-row": "Kalibratie tegen het modelantwoord",
    "learn.paper.leave": "Terug naar oefenen",

    "learn.marking.row-title": "Je onderbouwing",
    "learn.marking.in-progress": "Je argument wordt nagekeken",
    "learn.marking.in-progress-hint": "Je hoeft niet te wachten; je kunt het ook zelf nakijken.",
    "learn.marking.queued": "In de wachtrij",
    "learn.marking.queued-hint": "Het nakijken volgt zodra het kan; je antwoord is bewaard.",
    "learn.marking.offline-hint": "Zodra je weer verbinding hebt, wordt het nagekeken.",
    "learn.marking.signed-out-hint":
      "Log in om je argument te laten nakijken; zelf nakijken kan altijd.",
    "learn.marking.self": "Zelf nakijken",
    "learn.marking.self-title": "Kijk je argument zelf na",
    "learn.marking.self-hint": "Dit blijft op je toestel en wordt nergens verstuurd.",
    "learn.marking.self-save": "Klaar",
    "learn.marking.covered": "Gedekt",
    "learn.marking.partly": "Deels",
    "learn.marking.not-covered": "Niet genoemd",
    "learn.marking.result-title": "Wat je argument dekte",
    "learn.marking.quote": "Je schreef: “{quote}”",
    "learn.marking.appeal": "Laat opnieuw lezen",
    "learn.marking.readings": "Twee lezingen",
    "learn.marking.reading-earlier": "Eerder",
    "learn.marking.reading-now": "Nu",
    "learn.marking.limit-title": "Voor vandaag is het genoeg herlezen",
    "learn.marking.limit-body":
      "Je lezingen blijven bewaard. Morgen kun je opnieuw laten lezen, of kijk zelf na.",
    "learn.marking.error-title": "Je argument kon niet worden nagekeken",
    "learn.marking.retry": "Probeer opnieuw",
    "learn.marking.quota-title": "De nakijkhulp zit vandaag vol",
    "learn.marking.quota-body":
      "Je antwoord is bewaard en wordt later nagekeken. Zelf nakijken kan nu.",
    "learn.marking.budget-title": "Het nakijken is voor vandaag op",
    "learn.marking.budget-body": "Morgen gaat het weer door; je antwoord is bewaard.",
    "learn.marking.unwritten": "Hier stond geen tekst, dus er is niets om na te kijken.",
    "learn.marking.points": "{n} van 10",

    "learn.essays.title": "Je bewaarde antwoorden",
    "learn.essays.empty": "Je hebt geen bewaarde antwoorden.",
    "learn.essays.row": "Proefwerk {paper}",
    "learn.essays.state-marked": "Nagekeken",
    "learn.essays.state-pending": "Wacht op nakijken",
    "learn.essays.reread": "Opnieuw lezen",
    "learn.essays.delete-one": "Dit antwoord wissen",
    "learn.essays.delete-all": "Wis alle antwoorden",
    "learn.essays.confirm-one": "Dit antwoord en de lezingen worden gewist.",
    "learn.essays.confirm-all": "Alle antwoorden en lezingen worden gewist.",
    "learn.essays.deleted": "Gewist.",
    "learn.essays.error": "Je antwoorden konden niet worden opgehaald.",
    "learn.essays.offline": "Je bewaarde antwoorden hebben verbinding nodig.",
  },
  en: {
    "learn.practice.title": "Practise",
    "learn.practice.all": "All",
    "learn.practice.drills-title": "Practise without a glass",
    "learn.practice.drills-hint": "{n} exercises are ready",
    "learn.practice.primary": "Practise {n} items",
    "learn.practice.confusions-title": "Aimed at what you confuse",
    "learn.practice.confusion-pair": "{called} for {actual}",
    "learn.practice.confusion-count": "missed {n}×",
    "learn.practice.paper-title": "Timed paper",
    "learn.practice.paper-hint": "Two wines · {m} minutes · {sat} sat",
    "learn.practice.paper-start": "Sit a paper",
    "learn.practice.paper-locked": "Opens once every Level 2 lesson is complete.",
    "learn.practice.paper-locked-left": "{n} Level 2 lessons to go.",
    "learn.practice.empty-title": "Nothing to practise",
    "learn.practice.empty-body": "You do not need to do anything today to keep up.",
    "learn.practice.running-title": "Your paper is running",
    "learn.practice.running-resume": "Continue the paper",
    "learn.practice.running-left": "{time} left",
    "learn.practice.essays": "Your stored answers",
    "learn.practice.sync-error":
      "Your practice could not be updated; it is safe on this device and will be tried again later.",
    "learn.practice.sync-refused":
      "One part could not be updated and was set aside. The rest is up to date.",
    "learn.practice.mirror-damaged":
      "Part of your practice could no longer be read; we show what can still be read.",

    "learn.path.practice-hint": "Drills, confusions and a paper",
    "learn.path.mastery-hint": "Your levels, calibration and families",

    "learn.mastery.title": "Mastery",
    "learn.mastery.levels-title": "Per level",
    "learn.mastery.level": "Level {n}",
    "learn.mastery.calibration-title": "Calibration per axis",
    "learn.mastery.calibration-hint": "How far your ladder calls sit from the reference.",
    "learn.mastery.calibration-empty-title": "Nothing calibrated yet",
    "learn.mastery.calibration-empty-body":
      "Taste along in a group of three or more, or sit a paper.",
    "learn.mastery.families-title": "Accuracy by family",
    "learn.mastery.family-share": "{correct} of {total} right",
    "learn.mastery.family-empty": "Not tasted blind yet",
    "learn.mastery.spark-aria": "Per week: {weeks}",

    "learn.calibration.n-of-3": "{n} of {min}",
    "learn.calibration.on-target": "On target",
    "learn.calibration.lower": "You call lower",
    "learn.calibration.higher": "You call higher",
    "learn.calibration.basis": "Based on {n} calls",
    "learn.calibration.meter-aria": "{axis}: {word}, {steps} step, based on {n} calls",
    "learn.calibration.end-low": "Lower",
    "learn.calibration.end-high": "Higher",
    "learn.calibration.model-ref": "Reference: model answer, not a group",
    "learn.calibration.group-ref": "Reference: the group",
    "learn.calibration.no-reference": "No reference",
    "learn.calibration.too-few-title": "Too few tasters to calibrate",
    "learn.calibration.too-few-body":
      "Calibration needs a group of three or more. Sit a paper to calibrate against the model answer.",
    "learn.calibration.pending": "Calibration waits until the tasting is finished.",
    "learn.calibration.offline":
      "No connection: the group figure is not available yet. What you calibrated before stays.",
    "learn.calibration.screen-title": "Calibration",
    "learn.calibration.wine": "Wine {n}",
    "learn.calibration.you": "You",
    "learn.calibration.group": "Group",
    "learn.calibration.between": "between {a} and {b}",
    "learn.calibration.open": "Calibration of this tasting",
    "learn.calibration.to-paper": "Sit a paper",
    "learn.calibration.axis-acidity": "Acidity",
    "learn.calibration.axis-tannin": "Tannin",
    "learn.calibration.axis-flavour-intensity": "Flavour intensity",
    "learn.calibration.axis-body": "Body",
    "learn.calibration.axis-finish": "Finish",
    "learn.calibration.axis-aroma-intensity": "Aroma intensity",

    "learn.confusions.title": "Your confusions",
    "learn.confusions.how":
      "Each time you called another grape at a reveal we count the pair. A pair that comes back becomes a drill.",
    "learn.confusions.empty-title": "No confusions yet",
    "learn.confusions.empty-body":
      "Call a grape in a blind tasting and reveal it; what you miss shows up here.",
    "learn.confusions.times": "{n} times",
    "learn.confusions.drills-ready": "Drills ready",
    "learn.confusions.no-target": "No target yet",
    "learn.confusions.practise": "Practise your confusions",
    "learn.confusions.drill-target": "Targeted · {called} for {actual}",

    "learn.reveal.was": "It was",
    "learn.reveal.right": "Right",
    "learn.reveal.not-this": "Not this one",
    "learn.reveal.same-family": "Same family",
    "learn.reveal.not-named": "Not named",
    "learn.reveal.recorded": "Kept with your practice.",

    "learn.room.friends": "With friends or a group",
    "learn.room.title": "Paper with friends",
    "learn.room.name-label": "Your name in the room",
    "learn.room.create": "Open a room",
    "learn.room.code": "Code",
    "learn.room.share": "Invite people",
    "learn.room.share-title": "Sit along",
    "learn.room.share-text": "{name} is opening a two-wine paper. Will you join?",
    "learn.room.share-lead": "Only the room's name and its code go along; no answer.",
    "learn.room.host-only": "Pour these two styles (only you see this)",
    "learn.room.guest-wait": "Wait for the host to start. You see the styles at the reveal.",
    "learn.room.members": "Who is sitting",
    "learn.room.handed-in": "Handed in",
    "learn.room.busy": "Busy",
    "learn.room.start-all": "Start for everyone",
    "learn.room.clock-note": "The clock starts for everyone at once and runs on the room's time.",
    "learn.room.running": "The sitting is running",
    "learn.room.sit": "Go to your sitting",
    "learn.room.my-result": "Your own result",
    "learn.room.reveal": "Reveal for everyone",
    "learn.room.waiting-reveal": "Waiting for the host's reveal.",
    "learn.room.reveal-title": "Revealed together",
    "learn.room.outcome-right": "Right",
    "learn.room.outcome-family": "Same family",
    "learn.room.outcome-wrong": "Not this one",
    "learn.room.outcome-none": "Not named",
    "learn.room.wine": "Wine {n}",
    "learn.room.group-calibration": "Calibration against the group",
    "learn.room.half-step": "With an even number of tasters the median sits half a step between.",
    "learn.room.join-title": "Join a paper",
    "learn.room.join": "Join",
    "learn.room.not-found": "This room does not exist or is no longer open to you.",
    "learn.room.full": "The room is full.",
    "learn.room.error": "The room could not be updated.",
    "learn.room.handin-pending":
      "Your sitting is kept. Handing in to the room works as soon as you are connected.",
    "learn.room.handin-retry": "Hand in again",
    "learn.room.to-room": "To the room",
    "learn.room.back": "Back to practise",

    "learn.paper.title": "Paper",
    "learn.paper.ready-title": "Two wines, {m} minutes",
    "learn.paper.fact-pour": "Two pours of 5 cl; spitting is fine and part of it.",
    "learn.paper.fact-time": "After {m} minutes the sitting closes by itself.",
    "learn.paper.fact-note": "One deep note per wine and an argued judgement.",
    "learn.paper.fact-practice":
      "This is practice: you see your result, the model answer and what you missed.",
    "learn.paper.pour-title": "Pour these two styles",
    "learn.paper.pour-note":
      "Styles, not bottles: any bottle that fits, fits. Have someone else pour, or turn the labels away.",
    "learn.paper.budget": "Duration",
    "learn.paper.budget-1800": "30 min",
    "learn.paper.budget-1200": "20 min",
    "learn.paper.start": "Start the sitting",
    "learn.paper.locked-title": "The paper does not open yet",
    "learn.paper.locked-body": "Finish Level 2 first; then it is ready for you.",
    "learn.paper.locked-cta": "Continue Level 2",
    "learn.paper.not-found": "This paper does not exist.",
    "learn.paper.wine-tab": "Wine {n}",
    "learn.paper.wines-aria": "The wines of the paper",
    "learn.paper.elapsed-aria": "Time used",
    "learn.paper.section-points": "{n} points",
    "learn.paper.field-grape": "Grape",
    "learn.paper.field-country": "Country",
    "learn.paper.grape-pick": "Which grape?",
    "learn.families.picker-hint": "Family first, then the grape.",
    "learn.families.no-call": "No call · reveal without guessing",
    "learn.paper.grape-none": "Not chosen yet",
    "learn.paper.country-none": "Not chosen yet",
    "learn.paper.argument-label": "Argue your judgement in your own words",
    "learn.paper.argument-hint": "Typing nothing is fine; then only what you chose above counts.",
    "learn.paper.hand-in": "Hand in",
    "learn.paper.to-wine": "To wine {n}",
    "learn.paper.time-left-aria": "{m} minutes and {s} seconds left. Tap to hear the time.",
    "learn.paper.announce-ten-minutes": "Ten minutes left.",
    "learn.paper.announce-five-minutes": "Five minutes left.",
    "learn.paper.announce-one-minute": "One minute left.",
    "learn.paper.announce-closed": "The sitting is closed.",
    "learn.paper.last-minute": "One minute left. What is here will then be handed in.",
    "learn.paper.closed-title": "The sitting is closed",
    "learn.paper.closed-body": "Time is up; what was there has been handed in.",
    "learn.paper.closed-cta": "See the result",
    "learn.paper.empty-wine-title": "Wine {n} is still empty",
    "learn.paper.empty-wine-body": "An empty wine earns nothing.",
    "learn.paper.keep-going": "Keep writing",
    "learn.paper.hand-in-anyway": "Hand in anyway",
    "learn.paper.stop": "Stop",
    "learn.paper.stop-title": "Stop the sitting?",
    "learn.paper.stop-keep": "Keep going",
    "learn.paper.stop-leave": "Leave, the clock keeps running",
    "learn.paper.stop-abandon": "Stop without a result",
    "learn.paper.stop-abandoned": "The sitting has stopped. Your answers stay readable.",
    "learn.paper.corrupted-title": "A sitting could not be read",
    "learn.paper.corrupted-body": "The rest of your work is still here; we let this sitting go.",
    "learn.paper.band-emerging": "Building",
    "learn.paper.band-developing": "Developing",
    "learn.paper.band-secure": "Secure",
    "learn.paper.band-strong": "Strong",
    "learn.paper.band-note":
      "Four bands: building, developing, secure and strong. They say how far you are in this exercise, not whether you pass.",
    "learn.paper.band-range": "Between {low} and {high}",
    "learn.paper.result-title": "Your result",
    "learn.paper.score-of": "{n} of 100",
    "learn.paper.so-far": "{n} of 90 so far",
    "learn.paper.so-far-body": "The argument for your judgement still counts, up to {max}.",
    "learn.paper.pending-title": "Your score follows",
    "learn.paper.wine-result": "Wine {n}",
    "learn.paper.archetype-was": "It was {style}",
    "learn.paper.section-look": "Look",
    "learn.paper.section-nose": "Nose",
    "learn.paper.section-palate": "Palate",
    "learn.paper.section-conclusion": "Conclusion",
    "learn.paper.model-link": "Model answer and marking guide",
    "learn.paper.model-title": "Model answer and marking guide",
    "learn.paper.model-you": "You",
    "learn.paper.model-model": "Model",
    "learn.paper.mark-full": "Full",
    "learn.paper.mark-half": "Half",
    "learn.paper.mark-none": "None",
    "learn.paper.guide-look": "How to reach the look",
    "learn.paper.guide-nose": "How to reach the nose",
    "learn.paper.guide-palate": "How to reach the palate",
    "learn.paper.guide-quality": "How to argue the quality",
    "learn.paper.guide-grape": "How to reach the grape",
    "learn.paper.model-rules":
      "For each point you left behind there is one line on how you could have reached it yourself.",
    "learn.paper.share": "Share your result",
    "learn.paper.share-title": "My paper",
    "learn.paper.share-text": "My paper: {band}, {score} of 100, {date}.",
    "learn.paper.share-lead":
      "Only your band, your score and the date go along: no note and no answer.",
    "learn.paper.calibration-row": "Calibration against the model answer",
    "learn.paper.leave": "Back to practise",

    "learn.marking.row-title": "Your argument",
    "learn.marking.in-progress": "Your argument is being marked",
    "learn.marking.in-progress-hint": "You do not need to wait; you can also mark it yourself.",
    "learn.marking.queued": "Queued",
    "learn.marking.queued-hint": "Marking follows as soon as it can; your answer is kept.",
    "learn.marking.offline-hint": "As soon as you are connected again, it will be marked.",
    "learn.marking.signed-out-hint":
      "Sign in to have your argument marked; marking it yourself always works.",
    "learn.marking.self": "Mark it yourself",
    "learn.marking.self-title": "Mark your argument yourself",
    "learn.marking.self-hint": "This stays on your device and is sent nowhere.",
    "learn.marking.self-save": "Done",
    "learn.marking.covered": "Covered",
    "learn.marking.partly": "Partly",
    "learn.marking.not-covered": "Not named",
    "learn.marking.result-title": "What your argument covered",
    "learn.marking.quote": "You wrote: “{quote}”",
    "learn.marking.appeal": "Have it read again",
    "learn.marking.readings": "Two readings",
    "learn.marking.reading-earlier": "Earlier",
    "learn.marking.reading-now": "Now",
    "learn.marking.limit-title": "That is enough re-reading for today",
    "learn.marking.limit-body":
      "Your readings are kept. Tomorrow you can have it read again, or mark it yourself.",
    "learn.marking.error-title": "Your argument could not be marked",
    "learn.marking.retry": "Try again",
    "learn.marking.quota-title": "The marking aid is full for today",
    "learn.marking.quota-body":
      "Your answer is kept and will be marked later. You can mark it yourself now.",
    "learn.marking.budget-title": "Marking is used up for today",
    "learn.marking.budget-body": "It carries on tomorrow; your answer is kept.",
    "learn.marking.unwritten": "There was no written text here, so there is nothing to mark.",
    "learn.marking.points": "{n} of 10",

    "learn.essays.title": "Your stored answers",
    "learn.essays.empty": "You have no stored answers.",
    "learn.essays.row": "Paper {paper}",
    "learn.essays.state-marked": "Marked",
    "learn.essays.state-pending": "Waiting to be marked",
    "learn.essays.reread": "Read again",
    "learn.essays.delete-one": "Erase this answer",
    "learn.essays.delete-all": "Erase all answers",
    "learn.essays.confirm-one": "This answer and its readings will be erased.",
    "learn.essays.confirm-all": "All answers and readings will be erased.",
    "learn.essays.deleted": "Erased.",
    "learn.essays.error": "Your answers could not be fetched.",
    "learn.essays.offline": "Your stored answers need a connection.",
  },
} as const;
